/*
 * Small authored SVG icon set. Decorative by default (aria-hidden) — every icon
 * in the page is paired with a text label, so meaning never depends on the icon
 * or on colour alone.
 */

const base = {
  'aria-hidden': 'true',
  focusable: 'false',
  xmlns: 'http://www.w3.org/2000/svg',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export const ArrowRightIcon = ({ size = 18, ...props }) => (
  <svg {...base} width={size} height={size} viewBox="0 0 24 24" {...props}>
    <path d="M4 12h15" />
    <path d="m13 6 6 6-6 6" />
  </svg>
);

export const MenuIcon = ({ size = 22, ...props }) => (
  <svg {...base} width={size} height={size} viewBox="0 0 24 24" {...props}>
    <path d="M4 7h16" />
    <path d="M4 12h16" />
    <path d="M4 17h16" />
  </svg>
);

export const CloseIcon = ({ size = 22, ...props }) => (
  <svg {...base} width={size} height={size} viewBox="0 0 24 24" {...props}>
    <path d="m6 6 12 12" />
    <path d="m18 6-12 12" />
  </svg>
);

export const CheckCircleIcon = ({ size = 24, ...props }) => (
  <svg {...base} width={size} height={size} viewBox="0 0 24 24" {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="m8.5 12.2 2.4 2.4 4.6-4.9" />
  </svg>
);

export const AlertIcon = ({ size = 20, ...props }) => (
  <svg {...base} width={size} height={size} viewBox="0 0 24 24" {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7.75v4.75" />
    <path d="M12 16.25h.01" />
  </svg>
);

export const ExternalLinkIcon = ({ size = 15, ...props }) => (
  <svg {...base} width={size} height={size} viewBox="0 0 24 24" {...props}>
    <path d="M13.5 5H19v5.5" />
    <path d="M19 5l-7.5 7.5" />
    <path d="M18 14.5V18a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h3.5" />
  </svg>
);

export const AppleIcon = ({ size = 20, ...props }) => (
  <svg
    {...base}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    stroke="none"
    {...props}
  >
    <path d="M16.7 12.8c0-2.3 1.9-3.4 2-3.5a4.3 4.3 0 0 0-3.4-1.8c-1.5-.1-2.8.8-3.5.8-.7 0-1.8-.8-3-.8A4.5 4.5 0 0 0 5 9.8c-1.6 2.8-.4 6.9 1.1 9.2.8 1.1 1.7 2.3 2.9 2.2 1.2 0 1.6-.7 3.1-.7 1.4 0 1.9.7 3.1.7 1.3 0 2.1-1.1 2.8-2.2.9-1.3 1.3-2.6 1.3-2.7-.1 0-2.6-1-2.6-3.5ZM14.3 6c.6-.8 1.1-1.9 1-3-.9 0-2 .6-2.7 1.4-.6.7-1.1 1.8-1 2.9 1 .1 2-.5 2.7-1.3Z" />
  </svg>
);

export const AndroidIcon = ({ size = 20, ...props }) => (
  <svg
    {...base}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    stroke="none"
    {...props}
  >
    <path d="m17.6 9.5 1.7-2.9a.6.6 0 0 0-1-.6l-1.7 3a10.6 10.6 0 0 0-9.2 0L5.7 6a.6.6 0 1 0-1 .6l1.7 2.9A9.2 9.2 0 0 0 3 16h18a9.2 9.2 0 0 0-3.4-6.5ZM8 13.3a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm8 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM3 17h18v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2Z" />
  </svg>
);
